import React, { useEffect, useState } from "react";
import { Formik, FormikProvider, useFormik, Form, Field, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Modal, Row, Col, Button } from "react-bootstrap";
import { VscDiffAdded } from "react-icons/vsc";
import { BiTrash } from "react-icons/bi";
import CommonFormHeading from "../CommonUtils/CommonFormHeading";
import { ImagePdfBucket } from "../CommonUtils/ImagesBase64";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import { failureAlert, successAlert2, successAlertRefresh } from "../CommonUtils/SweetAlerts";
import { config } from "../CommonUtils/CommonURLS";
import Swal from "sweetalert2";
import { FaEdit, FaEye, FaTrash } from "react-icons/fa";
import { viewImage } from "../CommonUtils/viewImage";
import { convertToInputDate } from "../CommonUtils/CommonValidations";
// ---- Validation schema ----
const validationSchema = Yup.object().shape({
  newsandEventsEntryList: Yup.array().of(
    Yup.object().shape({
      newsDate: Yup.date().required("Date is required"),
      articalDescription: Yup.string().required("Description is required"),
      articalFile1: Yup.mixed().required("PDF is required"),
    }),
  ),
});

export default function NewsEvents() {
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [newsEventsReuploadedRows, setNewsEventsReuploadedRows] = useState({});
  const formik = useFormik({
    initialValues: {
      newsandEventsEntryList: [
        {
          newsDate: "",
          articalDescription: "",
          articalFile1: "",
        },
      ],
    },

    validationSchema,

    onSubmit: (values, { resetForm }) => {
      console.log("values", values, isEdit);
      Swal.fire({
        text: "Are you sure you want to submit?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, submit it!",
        cancelButtonText: "No, cancel!",
        backdrop: false,
      }).then((result) => {
        if (result.isConfirmed) {
          console.log("isEdit", isEdit);
          const url = isEdit ? `${config.url.STU_URL}updateNewsandEvents` : `${config.url.STU_URL}saveNewsandEventsEntry`;

          // const payload = isEdit
          //     ? {
          //         artical_id: editId,
          //         ...values,
          //     }
          //     : values;

          let payload;

          if (isEdit) {
            payload = {
              // artical_id: editId,
              newsandEventsEntryList: values.newsandEventsEntryList.map((item) => ({
                articalId: editId,
                newsDate: item.newsDate,
                articalDescription: item.articalDescription,
                articalFile1: item.articalFile1,
              })),
            };
          } else {
            payload = values;
          }
          CommonAxiosPost(url, payload).then((res) => {
            if (res?.data?.scode === "01") {
              successAlertRefresh(res?.data?.sdesc);

              GetNewsData();

              // resetForm();

              setShowModal(false);

              setIsEdit(false);

              setEditId(null);
            } else {
              failureAlert(res?.data?.sdesc);
            }
          });
        } else {
          console.log("Submission canceled");
        }
      });
    },
  });

  const [news, setNews] = useState([]);
  function GetNewsData() {
    let url = config.url.STU_URL + `ov-public/getNewsandEvents`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        setNews(res?.data?.data);
      } else {
        setNews([]);
      }
    });
  }

  useEffect(() => {
    GetNewsData();
  }, []);

  const handleOpenModal = () => {
    setIsEdit(false);
    setEditId(null);
    setNewsEventsReuploadedRows({});

    formik.resetForm();

    setShowModal(true);
  };

  const handleCloseModal = () => {
    formik.resetForm();

    setIsEdit(false);

    setEditId(null);
    setNewsEventsReuploadedRows({});

    setShowModal(false);
  };

  const handleEdit = (item) => {
    setIsEdit(true);
    setEditId(item.artical_id);
    setNewsEventsReuploadedRows({});

    formik.setValues({
      newsandEventsEntryList: [
        {
          newsDate: convertToInputDate(item.news_date),
          articalDescription: item.artical_description || "",
          articalFile1: item.artical_file1 || "",
        },
      ],
    });

    setShowModal(true);
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Delete News & Event",
      text: "Are you sure you want to delete this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
      backdrop: false,
    }).then((result) => {
      if (result.isConfirmed) {
        console.log("Delete:", id);

        let url = config.url.STU_URL + `deleteNewsandEntry?articalId=${id}`;
        CommonAxiosPost(url).then((res) => {
          if (res?.data?.scode === "01") {
            successAlert2(res?.data?.data);
            GetNewsData();
          } else {
            failureAlert(res?.data?.data);
          }
        });
      }
    });
  };
  console.log("Ffffffffffff", formik?.values, "dd", news.length);

  return (
    <div className="affl-newdiv">
      <CommonFormHeading heading="News & Events" />

      <div className="col-12">
        <Row>
          <Col xs={12} sm={12} md={12} lg={10} xl={10} xxl={10} />
          <Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
            <div className="d-flex flex-row justify-content-end">
              <Button type="button" size="sm" variant="primary" onClick={handleOpenModal}>
                + Add News & Events
              </Button>
            </div>
          </Col>
        </Row>
      </div>
      <br />
      {/* {news?.length > 0 && (<></>)} */}
      {news?.length > 0 && (
        <>
          <div className="table-responsive">
            <table className="table table-bordered table-sm affl-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Date</th>
                  <th className="text-start">Description</th>
                  <th>PDF</th>
                  <th className="text-center">Edit / Delete</th>
                </tr>
              </thead>

              <tbody>
                {news.map((item, index) => (
                  <tr key={index}>
                    <td className="text-center">{index + 1}</td>

                    <td>{item.news_date}</td>

                    <td>{item.artical_description || "-"}</td>

                    <td className="text-center">
                      {item.artical_file1 ? (
                        <button type="button" className="btn btn-sm btn-success" onClick={() => viewImage(item.artical_file1)}>
                          <FaEye />
                        </button>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="text-center">
                      <button className="btn btn-sm btn-primary me-2">
                        <FaEdit onClick={() => handleEdit(item)} />
                      </button>

                      <button className="btn btn-sm btn-danger">
                        <FaTrash onClick={() => handleDelete(item.artical_id)} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* ---- Add News & Events Modal ---- */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered className="inner-modalnew">
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? "Edit News & Events" : "Add News & Events"}</Modal.Title>
        </Modal.Header>
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit} onChange={formik.handleChange}>
            <Modal.Body>
              <div className="table-responsive">
                <table className="table table-condensed table-bordered table-sm affl-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Date</th>
                      <th className="text-left">Description</th>
                      <th>Upload PDF</th>
                      {!isEdit && <th>Action</th>}
                    </tr>
                  </thead>
                  <tbody>
                    <FieldArray name="newsandEventsEntryList">
                      {({ push, remove }) => (
                        <>
                          {formik.values.newsandEventsEntryList.map((detail, index) => (
                            <tr key={index}>
                              <td>
                                <center>{index + 1}</center>
                              </td>
                              <td>
                                <Field type="date" className="form-control" name={`newsandEventsEntryList[${index}].newsDate`} />
                                <ErrorMessage name={`newsandEventsEntryList[${index}].newsDate`} component="div" className="text-error" />
                              </td>
                              <td>
                                <Field as="textarea" rows={2} className="form-control" name={`newsandEventsEntryList[${index}].articalDescription`} placeholder="Enter description" />
                                <ErrorMessage name={`newsandEventsEntryList[${index}].articalDescription`} component="div" className="text-error" />
                              </td>
                              {/* <td>
                                                                    <input
                                                                        type="file"
                                                                        className="form-control mt-3 mb-2"
                                                                        accept="application/pdf"
                                                                        onChange={(e) => {
                                                                            const fieldName = `newsandEventsEntryList[${index}].articalFile1`;

                                                                            ImagePdfBucket(
                                                                                e,
                                                                                formik,
                                                                                "/ApKwdc/Uploads/articalFile1/",
                                                                                fieldName,          // Formik field name
                                                                                `article_${index}`, // Uploaded file name
                                                                                "pdf"               // File type
                                                                            );
                                                                        }}
                                                                    />

                                                                    <ErrorMessage
                                                                        name={`newsandEventsEntryList[${index}].articalFile1`}
                                                                        component="div"
                                                                        className="text-error"
                                                                    />

                                                                </td> */}
                              <td>
                                {isEdit && detail.articalFile1 && typeof detail.articalFile1 === "string" && !newsEventsReuploadedRows[index] && (
                                  <div className="mb-2">
                                    <span
                                      role="button"
                                      tabIndex={0}
                                      className="text-primary text-decoration-underline"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => viewImage(detail.articalFile1)}
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {
                                          e.preventDefault();
                                          viewImage(detail.articalFile1);
                                        }
                                      }}
                                    >
                                      View Existing PDF
                                    </span>
                                  </div>
                                )}

                                <input
                                  type="file"
                                  className="form-control mt-3 mb-2"
                                  accept="application/pdf"
                                  name={`newsandEventsEntryList[${index}].articalFile1`}
                                  onChange={(e) => {
                                    const fieldName = `newsandEventsEntryList[${index}].articalFile1`;

                                    const fileName = `${Date.now()}_article_${index}`;

                                    const path = "/ApKwdc/Uploads/articalFile1/";

                                    ImagePdfBucket(e, formik, path, fieldName, fileName, "pdf");
                                  }}
                                />
                              </td>
                              {!isEdit && (
                                <td align="center">
                                  {index === 0 && (
                                    <button
                                      type="button"
                                      className="button-title btn btn-sm btn-success"
                                      onClick={() =>
                                        push({
                                          newsDate: "",
                                          articalDescription: "",
                                          articalFile1: "",
                                        })
                                      }
                                    >
                                      <VscDiffAdded />
                                    </button>
                                  )}
                                  {index >= 1 && (
                                    <button type="button" className="button-title btn btn-sm btn-danger" onClick={() => remove(index)}>
                                      <BiTrash />
                                    </button>
                                  )}
                                </td>
                              )}
                            </tr>
                          ))}
                        </>
                      )}
                    </FieldArray>
                  </tbody>
                </table>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" size="sm" onClick={handleCloseModal}>
                Cancel
              </Button>
              <Button
                type="submit"
                size="sm"
                variant="success"
                onClick={() => {
                  console.log("Button clicked");
                  console.log(formik.errors);
                }}
              >
                {isEdit ? "Update" : "Submit"}
              </Button>
            </Modal.Footer>
          </Form>
        </FormikProvider>
      </Modal>
    </div>
  );
}
